import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import VideoPlaceHolder from '../../assets/images/VideoPlaceHolder.jpg';
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable no-case-declarations */
/* eslint-disable react-hooks/exhaustive-deps */
import { CircledPlayButton } from '../../Constants/assets';
import VideoModal from '../VideoModal/VideoModal';


const VideoDiv = styled.div`
    cursor:pointer;
    // height:85px;
    // width:151px;
    z-index: 0;
`

const VideoOverlay = styled.div`
    opacity:0.7;
    background-color: black;
    //     height:85px;
    // width:151px;
    position: relative;
`


const VideoTemplate = prop => {
    const { t } = useTranslation();
    const [videoLink, setVideoLink] = useState({
        thumbnail:VideoPlaceHolder,
        videoLink:false
    }) // Some placeholder for video image.
    const [retry, setRetry] = useState(true)
    const [show, setShow] = useState(false)


    useEffect(()=>{
        const getThumbnail = async (link) => {
            const instance = axios.create({ // Create new axios instance to prevent retrying on bad site link.
                baseURL: `https://vimeo.com/api/v2/video`,
                timeout: 1000,
            });
            const videoId = link.split('/')
            try{
                if(retry){
                    instance.get(`/${videoId[videoId.length - 1]}.json`)
                    .then((res)=>{
                        setVideoLink(prev => ({
                            thumbnail: res.data[0].thumbnail_medium,
                            title: res.data[0].title,
                            videoLink: `https://player.vimeo.com/video/${videoId[videoId.length - 1]}?h=0bdc37885e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`
                        }));
                        setRetry(false)
                    }).catch(e=>{setRetry(false)})
                }

            } catch(e){
                console.log(e);
            }
        }
        getThumbnail(prop.videoLink)
        // const thumb = getThumbnail(prop.videoLink)
        // console.log(thumb);
        // const proprss = setVideoLink(prev => ({
        //     ...prev,
        //     thumbnail: thumb
        // }));
    },[prop.videoLink])

    return (
        <>
            <VideoModal
                videoLink={videoLink?.videoLink}
                show={show}
                setShow={setShow}
            />
            <VideoDiv onClick={videoLink?.videoLink ? ()=>{setShow(true)} : ()=>{}}>
                <VideoOverlay title={videoLink?.title}>
                    <CircledPlayButton
                        style={{position: 'absolute', top:'50px', right:'75px'}}
                    />
                    <img
                        // style={{height:"85px", width:"151px"}} 
                        src={videoLink.thumbnail}
                        alt="video_template"
                        onError={()=>{
                            setVideoLink(prev =>({ 
                                ...prev,
                                thumbnail:VideoPlaceHolder
                            })
                        )}}
                    /> 
                </VideoOverlay>
                <p style={{width:'200px', height:'60px'}}>
                    {t(`login.help.help_videos.videos.${prop.id}.video_title`, {id: prop.id})}
                </p>
            </VideoDiv>
        </>
    )

};

export default VideoTemplate